export function getYearForTitle(): number {
  const today = new Date()
  const currentYear = today.getUTCFullYear()
  // Month is 0-indexed in JS, 8 = September

  const septemberFirstThisYear = new Date(Date.UTC(currentYear, 8, 1))
  const januaryFirstNextYear = new Date(Date.UTC(currentYear + 1, 0, 1))

  if (today >= septemberFirstThisYear && today < januaryFirstNextYear) {
    return currentYear + 1
  }
  return currentYear
}

export function getYearForTitleDate(): Date {
  return new Date(Date.UTC(getYearForTitle(), 0, 2))
}
